// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_eb-3";
export var flatBottomCorners = "_eb-5";
export var productImage = "_eb-0";
export var quantityContainer = "_eb-2";
export var quantityHeader = "_eb-6";
export var tooltip = "_eb-1";
export var wrapAndEllipsesOverflow = "_eb-4";